import React, { ReactElement } from 'react'
import { TeaserTypes } from '../../TeaserInterface'
import { LabelProps } from '../../../BaseComponents/Labels/Types'
import VideoLabelProps from '../../../BaseComponents/Labels/Video/VideoLabelProps'
import BigTeaserArticleImage from './Article'
import BigTeaserVideoImage from './Video'
import BigTeaserGalleryImage from './Gallery'

type BigTeaserImageProps = LabelProps &
    VideoLabelProps & {
        type: TeaserTypes
        imageUrl?: string
        alt?: string
        videoDuration?: string
        isTopStory?: boolean
        webIsInFirstViewport?: boolean
    }

const BigTeaserImage = ({
    imageUrl,
    alt,
    labels,
    type,
    videoDuration,
    isTopStory,
    teaserIcon,
    webIsInFirstViewport = false,
}: BigTeaserImageProps): ReactElement => {
    const commonProps = {
        width: '100%',
        imageUrl,
        alt,
        labels,
        isTopStory,
        teaserIcon,
    }
    if (type === 'VIDEO') {
        return <BigTeaserVideoImage videoDuration={videoDuration} {...commonProps} />
    } else if (type === 'GALLERY') {
        return <BigTeaserGalleryImage {...commonProps} />
    }
    return <BigTeaserArticleImage webIsInFirstViewport={webIsInFirstViewport} {...commonProps} />
}

export default BigTeaserImage
